import update from 'immutability-helper'

export function show (id, { successCallback, errorCallback, props } = {}) {
  return {
    type: 'MODALS_SHOW',
    id,
    successCallback,
    errorCallback,
    props
  }
}

export function hide (id) {
  return {
    type: 'MODALS_HIDE',
    id
  }
}

export const actions = { show, hide }

// Action Handlers
const ACTION_HANDLERS = {
  MODALS_SHOW: (state = initialState, action) => {
    return update(
      state,
      {
        [action.id]: {
          $set: {
            id: action.id,
            open: true,
            successCallback: action.successCallback,
            errorCallback: action.errorCallback,
            props: action.props
          }
        }
      }
    )
  },
  MODALS_HIDE: (state, action) => {
    if (!state[action.id]) return state // nothing to hide if we haven't initiated it yet

    return update(
      state,
      {
        [action.id]: {
          open: { // nested ~ modal[id].open
            $set: false
          }
        }
      }
    )
  }
}

// Reducer
const initialState = {}

// NOTE: This `reducer` doesn't seem to be going anywhere....
export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/modals.js